// ===========================================
// PRODUCTION CONFIGURATION
// ===========================================

// App Store URL — the canonical mobile install destination.
// Used by every "Download on the App Store" CTA across the marketing site.
export const APP_STORE_URL = 'https://apps.apple.com/us/app/podbrief/id6759987252';

// Rate limiting
export const FREE_BRIEFS_PER_IP_PER_DAY = 20;

// Note: duration limits (5 minutes – 5 hours) are enforced server-side in
// generate-brief and generate-youtube-brief edge functions (search results
// are also pre-filtered to this range by youtube-search).

// Turnstile site key
export const TURNSTILE_SITE_KEY = "0x4AAAAAACI0PXYuZJNNCGMk";

// Available languages
// Note: xAI handles locale variants for pronunciation (pt-BR vs pt-PT, ar-SA vs ar-EG).
// Gemini strips the variant and treats summaries by base language.
export const LANGUAGES = [
  { value: "ar-SA", label: "Arabic (Saudi Arabia)" },
  { value: "ar-EG", label: "Arabic (Egypt)" },
  { value: "ar-AE", label: "Arabic (UAE)" },
  { value: "zh", label: "Chinese (Simplified)" },
  { value: "en", label: "English" },
  { value: "fr", label: "French" },
  { value: "de", label: "German" },
  { value: "hi", label: "Hindi" },
  { value: "it", label: "Italian" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "pt-BR", label: "Portuguese (Brazil)" },
  { value: "pt-PT", label: "Portuguese (Portugal)" },
  { value: "ru", label: "Russian" },
  { value: "es", label: "Spanish" },
  { value: "es-MX", label: "Spanish (Mexico)" },
] as const;

// xAI TTS Voices — descriptions match xAI's official voice personalities
export const XAI_VOICES = [
  { id: "eve", name: "Eve", tone: "Energetic & upbeat", description: "Engaging and enthusiastic — great default for lively summaries." },
  { id: "ara", name: "Ara", tone: "Warm & friendly", description: "Balanced and conversational — natural for everyday listening." },
  { id: "rex", name: "Rex", tone: "Confident & clear", description: "Professional and articulate — ideal for business and news." },
  { id: "sal", name: "Sal", tone: "Smooth & balanced", description: "A versatile voice that fits a wide range of content." },
  { id: "leo", name: "Leo", tone: "Authoritative & strong", description: "Commanding and decisive — great for instructional content." },
] as const;


export function getLanguageLabel(code: string): string {
  return LANGUAGES.find((lang) => lang.value === code)?.label || "English";
}

export function getVoiceLabel(voiceId: string | null | undefined): string | null {
  if (!voiceId) return null;
  return XAI_VOICES.find((v) => v.id === voiceId)?.name || null;
}

